import { gql } from "graphql-request";

const SERVER_CHANGE_STATUS_COST_CENTER_CONTRACT = gql`
  mutation SERVER_ChangeStatusCostCenterContract($id: ID!, $status: CostCenterContractStatus!) {
    changeStatusCostCenterContract(id: $id, status: $status)
  } 
`;
export default SERVER_CHANGE_STATUS_COST_CENTER_CONTRACT;
